const config = {
    API_URL: "https://reastaurant-app.herokuapp.com"
    //API_URL: "http://localhost:5000"
}
export default config;